// audiencia.js — Variantes de una sección según el país / perfil del visitante
//
// Cualquier sección de la landing puede llevar en su config:
//
//   variantes_audiencia: [
//     { id, nombre: 'Educare', paises: ['BR'], subroles: ['educare'], config: { ...overrides } },
//     ...
//   ]
//
// Al pintar, la primera variante que le calce al visitante se mezcla ENCIMA de
// la config base (merge superficial: solo las claves que la variante define).
// Sin variantes, la config se devuelve tal cual → las secciones existentes de
// todos los demás proyectos no cambian en nada.
import { normalizarPais } from '../../utils/pais';

// ¿La lista de la variante incluye a alguno de los identificadores del
// visitante? Devuelve null cuando la lista está vacía = "este criterio no
// filtra". Se comparan varios identificadores (código, sigla y nombre del país)
// porque el admin pudo guardar la variante con cualquiera de ellos.
const enLista = (lista, identificadores) => {
  if (!Array.isArray(lista) || lista.length === 0) return null;
  const ids = (Array.isArray(identificadores) ? identificadores : [identificadores])
    .filter(Boolean)
    .map(normalizarPais);
  if (ids.length === 0) return false;
  return lista.some(x => ids.includes(normalizarPais(x)));
};

// Todas las formas en que puede venir nombrado el país del visitante.
const idsPais = (audiencia) => (
  Array.isArray(audiencia.paisIds) && audiencia.paisIds.length > 0
    ? audiencia.paisIds
    : [audiencia.pais, audiencia.paisNombre]
);

// Devuelve la variante que aplica, o null.
export const variantePara = (config, audiencia = {}) => {
  const variantes = Array.isArray(config?.variantes_audiencia) ? config.variantes_audiencia : [];
  if (variantes.length === 0) return null;
  const paises = idsPais(audiencia);
  return variantes.find(v => {
    if (!v || v.activa === false) return false;
    const okPais = enLista(v.paises, paises);
    const okSubrol = enLista(v.subroles, audiencia.subrol);
    // Una variante sin ningún criterio no aplica nunca (evita que una variante
    // a medio configurar tape la config base para todo el mundo).
    if (okPais === null && okSubrol === null) return false;
    return okPais !== false && okSubrol !== false;
  }) || null;
};

// Config efectiva de la sección para este visitante.
export const resolverConfigAudiencia = (config, audiencia) => {
  const v = variantePara(config, audiencia);
  if (!v || !v.config || typeof v.config !== 'object') return config;
  return { ...config, ...v.config };
};

export default resolverConfigAudiencia;
